import React, {useState, useEffect} from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import {
    formatDropDownDataSource,
    formatSelectedOption,
    customFilterOption,
} from '../../utils/utils'
import {apiRequest} from '../../utils/apiHelper'
import {API_URL_RESOURCE} from '../../utils/constants'
import {
    FormControl,
    Grid,
    FormHelperText,
    InputLabel,
    Tooltip,
    InputAdornment,
    IconButton,
} from '@material-ui/core'
import {SelectIcon} from '../SelectIcon/SelectIcon'
import MarkdownRender from '../MarkdownRender'

const customStyles = {
    multiValueLabel: (styles, {data}) => ({
        ...styles,
        'white-space': 'normal',
    }),
}

const ReactSelect = props => {
    const [optionList, setOptionList] = useState([])
    const [loading, setloading] = useState(props.fetchData ? true : false)
    const currentValue = props.endPoint
        ? formatSelectedOption(props.fieldValue, props.endPoint)
        : props.fieldValue

    useEffect(() => {
        if (props.fetchData) {
            const callApi = async () => {
                setloading(true)
                const response = await apiRequest(
                    `${API_URL_RESOURCE.URL}${props.endPoint}`,
                    props.param,
                    props.endPointHeader
                )
                setOptionList(
                    response.success
                        ? formatDropDownDataSource(response.success, props.endPoint)
                        : []
                )
                setloading(false)
            }
            callApi()
        } else if (props.data) setOptionList(props.data)
    }, [])

    useEffect(() => {
        setOptionList(props.data)
    }, [props.data])

    const handleChange = option => {
        if (props.multiSelect) {
            let selectedOptions = []
            if (option)
                selectedOptions = option.map(p => (p.obj === undefined ? p : p.obj))
            props.onChange(selectedOptions)
        } else props.onChange(option ? option.obj : {})
    }

    if (!props.toShow) {
        return null
    }

    const selectedOptVal = props.multiSelect
        ? currentValue
        : currentValue
        ? currentValue.hasOwnProperty('value')
            ? currentValue.value !== undefined &&
              currentValue.value !== null &&
              currentValue.value !== ''
                ? currentValue
                : 0
            : 0
        : 0

    return (
        <Grid
            item
            xs={12}
            md
            className={`react-select-grid input-field__main_container ${props.cssClass}`}
        >
            <FormControl
                fullWidth
                error={props.errorText ? true : false}
                className="input-field__container"
            >
                <InputLabel
                    required={props.required}
                    data-shrink={true}
                    className="react-select-label"
                >
                    <span className="react-select-label__text">{props.fieldName}</span>
                    <span className="react-sel-lbl__helper-text">
                        {props.icon && (
                            <Tooltip
                                title={
                                    props.icon.toolTip ? (
                                        <MarkdownRender value={props.icon.toolTip} />
                                    ) : (
                                        ''
                                    )
                                }
                                placement={props.icon.toolTipPlacement}
                                arrow={props.icon.isArrow}
                            >
                                <InputAdornment hide="true" position="end">
                                    <IconButton>
                                        <SelectIcon {...props} />
                                    </IconButton>
                                </InputAdornment>
                            </Tooltip>
                        )}
                    </span>
                </InputLabel>
                <Select
                    className="basic-single"
                    classNamePrefix="select"
                    // defaultValue={props.defaultValue}
                    value={selectedOptVal}
                    isDisabled={props.isDisabled || props.isDisable}
                    isLoading={loading || props.isLoading}
                    isClearable={props.isClearable}
                    isSearchable={props.isSearchable}
                    name={props.name}
                    isMulti={props.multiSelect}
                    options={optionList}
                    onChange={handleChange}
                    placeholder={props.placeholder}
                    filterOption={customFilterOption}
                    theme={theme => ({
                        ...theme,
                        borderRadius: 0,
                    })}
                    styles={customStyles}
                    closeMenuOnSelect={props.multiSelect ? false : true}
                />
                <FormHelperText>{props.errorText}</FormHelperText>
            </FormControl>
            {props.note && (
                <Grid className={`guidline`}>
                    <MarkdownRender value={props.note} />
                </Grid>
            )}
        </Grid>
    )
}

ReactSelect.propTypes = {
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    isClearable: PropTypes.bool,
    isSearchable: PropTypes.bool,
    data: PropTypes.array,
    placeholder: PropTypes.string,
    multiSelect: PropTypes.bool,
    toShow: PropTypes.bool,
}

ReactSelect.defaultProps = {
    isDisabled: false,
    isLoading: false,
    isClearable: true,
    isSearchable: true,
    data: [],
    placeholder: '',
    multiSelect: false,
    toShow: true,
}

export default ReactSelect
